<template>
<!-- Main sidebar -->
<div class="sidebar sidebar-dark sidebar-main sidebar-expand-md">

    <!-- Sidebar mobile toggler -->
    <div class="sidebar-mobile-toggler text-center">
        <router-link to="#" class="sidebar-mobile-main-toggle">
            <i class="icon-arrow-left8"></i>
        </router-link>
        {{ $t("Goship") }}
        <router-link to="#" class="sidebar-mobile-expand">
            <i class="icon-screen-full"></i>
            <i class="icon-screen-normal"></i>
        </router-link>
    </div>
    <!-- /sidebar mobile toggler -->

    <!-- Sidebar content -->
    <div class="sidebar-content">
        <!-- Main navigation -->
        <div class="card card-sidebar-mobile">
            <ul class="nav nav-sidebar" data-nav-type="accordion">

                <!-- Main -->
                <li class="nav-item">
                    <router-link :to="{name: 'account.stores'}" class="nav-link"><i class="fas fa-store"></i><span>{{ $t("Stores") }}</span></router-link>
                </li>

                <li class="nav-item">
                    <router-link :to="{name: 'account.profile'}" class="nav-link"><i class="fas fa-user-circle"></i><span>{{ $t("Your Profile")}}</span></router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{name: 'account.referfriends'}" class="nav-link"><i class="fa-solid fa-users-medical"></i><span>{{ $t("Refer Friends")}}</span></router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{name: 'account.security'}" class="nav-link"><i class="fas fa-shield-check"></i><span>{{ $t("Security")}}</span></router-link>
                </li>


                <!-- /page kits -->

            </ul>
        </div>
        <!-- /main navigation -->

    </div>
    <!-- /sidebar content -->

</div>
<!-- /main sidebar -->
</template>

<script>
export default {
    name: 'LeftMenu',
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/layouts/central/admin/LeftMenu.vue